define(['jquery', 'slick'], function($, slick) {

	$('.slick').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		prevArrow: '<button class="left"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
		nextArrow: '<button class="right"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
		responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				infinite: true,
				dots: true
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
		]
	});
});